/**
 * WordPress dependencies
 */
import { 
	InnerBlocks, 
	useBlockProps,
	__experimentalGetSpacingClassesAndStyles as getSpacingClassesAndStyles, 
} from '@wordpress/block-editor';

const Save = ( { attributes } ) => {

	const blockProps = useBlockProps.save();
	const { id, redirectUrl, successMessage } = attributes;

	const context = {
		redirectUrl,
		successMessage,
	}

	return (
		<form
			{ ...blockProps }
			data-id={ id }
			name={ 'popper-form-' + id }
			data-redirect={ redirectUrl }
			data-wp-on--submit="actions.sendForm"
			data-wp-context={ JSON.stringify( context ) }
		>
			<InnerBlocks.Content />
			<div
				className="popper-message"
				data-wp-class--success="context.response.success"
				data-wp-class--error="!context.response.success"
			>
				<p data-wp-text="state.message"></p>
				<ul data-wp-context="state.errors">
					<template data-wp-each="state.errors">
						<li data-wp-text="context.item"></li>
					</template>
				</ul>
			</div>
		</form>
	);
};
export default Save;
